// extracted by mini-css-extract-plugin
module.exports = {"root":"WelcomeStep_root__yRPGq","title":"WelcomeStep_title__c7w_O","subtitle":"WelcomeStep_subtitle__Dpve6","actionButton":"WelcomeStep_actionButton__xlJyp"};